// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__3MEiv","lottie":"loading_lottie__38kAf"};